import React, { ChangeEvent, useEffect, useMemo, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { PiArrowLeftBold } from "react-icons/pi";
import { PiTrashBold } from "react-icons/pi";
import LOGO from './../assets/images/vyapar_live_main_logo.png';
import { ApisService } from '../app/core/apis.service';
import { dataDecrypt, dataEncrypt } from '../app/utils/encryption-helper';
import { AppConfig } from '../app/config';
import NoProductImage from './../assets/images/no_product_image.png';
import NordersImage from './../assets/images/no_orders_found.jpg';
import { Dispatch } from 'redux';
import { BU_DETAILS } from '../app/store/action-types';
import { connect } from 'react-redux';
import { Card, CardBody, Offcanvas } from 'react-bootstrap';
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";
import Modal from 'react-bootstrap/Modal';

interface Props {
    updateBuDetails?: (data: any) => void;
}

const OrderFormListPage = (props: Props) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [productsData, setProductsData] = useState<any>([]);
    const [selectedProducts, setSelectedProducts] = useState<any>([]);
    const [showUserDetailsForm, setShowUserDetailsForm] = useState<boolean>(false);
    const [showPlaceOrderButtonText, setShowPlaceOrderButtonText] = useState<boolean>(false);
    const [showUSerDetailsData, setShowUSerDetailsData] = useState<boolean>(false);
    const [buDetailsData, setBuDetailsData] = useState<any>([])
    const [buAddressData, setBuAddressData] = useState<any>({});
    const [lastValidQty, setLastValidQty] = useState<{ [id: string]: number }>({});
    const [formErrors, setFormErrors] = useState<any>([]);
    const [view, setView] = useState<boolean>();
    const [show, setShow] = useState<boolean>();
    const [selectedProduct, setSelectedProduct] = useState<any>();
    const navigation = useNavigate();
    const mobileNumberRegex = /^[6-9]\d{9}$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-z]+.[a-z]{2,6}$/;
    const [userDetailsData, setUserDetailsData] = useState<any>({
        name: "",
        contact_number: "",
        email: "",
        address: "",
    })
    const [productErrors, setProductErrors] = useState<any>({});
    const routerParams: any = useParams();
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
    const debounceRef = useRef<NodeJS.Timeout | null>(null);

    // Update debounced value 300ms after user stops typing
    useEffect(() => {
        if (debouncedSearchTerm !== undefined) {
            const routeData = JSON.parse(dataDecrypt(routerParams.id));
            const payload = {
                id: routeData?.id,
                filter: { name: debouncedSearchTerm },
            };
            const encryptPayload = dataEncrypt(JSON.stringify(payload));
            loadProducts(encryptPayload);
        }
    }, [debouncedSearchTerm]);

    // Optional: clear timeout on unmount
    useEffect(() => {
        return () => {
            if (debounceRef.current) clearTimeout(debounceRef.current);
        };
    }, []);

    useEffect(() => {
        loadProducts(routerParams.id);
        loadBuDetails();
        setView(false);
        setSelectedProduct(null);
        setShow(false);
    }, []);


    async function loadProducts(payload: any): Promise<void> {
        setLoading(true)
        try {
            const res = await ApisService.getProductData('findProductList_v2', payload || '');
            const data: any = res.data.data;
            const productData = JSON.parse(dataDecrypt(data));
            const sorted = [...productData?.results].sort((a, b) => {
                const isAAlpha = /^[A-Za-z]/.test(a.name);
                const isBAlpha = /^[A-Za-z]/.test(b.name);

                if (isAAlpha && !isBAlpha) return -1;
                if (!isAAlpha && isBAlpha) return 1;

                return a.name.localeCompare(b.name);
            });
            const filterProductsData = sorted?.filter((el: any) => el?.for_sale === true && el?.in_stock === true);
            filterProductsData.forEach((product: any) => {
                product.unit = product?.batch_pricing[0]?.unit;
            });
            setProductsData(filterProductsData);
            setLoading(false);
        } catch (error) {
            setLoading(false)
        }
    }

    async function loadBuDetails(): Promise<void> {
        setLoading(true)
        try {
            // const id = "908b88a1939383024c36570992489ee3be209a4f0a0d11da4068c8c956c8a41b18fecc3d084e6c0d12c4cfe532d50562";
            const res = await ApisService.getBuDetailsData('findById', routerParams.id || '');
            const data: any = res.data.data;
            const buData = JSON.parse(dataDecrypt(data));
            setBuDetailsData(buData[0])
            setBuAddressData(buData[0]?.contact_details?.address)
            setLoading(false);

            if (props.updateBuDetails) {
                props.updateBuDetails(buData[0]);
            }
        } catch (error) {
            console.error('Error in products:', error);
            setLoading(false)
        }
    }

    const formatCurrency = (amount: number) => {
        const formattedAmount = amount?.toLocaleString('en-IN', { maximumFractionDigits: 2 });
        if (amount > 10000) {
            return `₹ ${formattedAmount}`;
        } else if (amount === undefined) {
            return "-";
        } else {
            return `₹ ${formattedAmount}`;
        }
    };

    const handleInputChange = (
        e: ChangeEvent<HTMLInputElement>,
        product: any,
        index: number
    ) => {
        const raw = e.target.value;
        if (raw === "") {
            const updatedSelectedProducts = [...selectedProducts];
            const existingProductIndex = updatedSelectedProducts.findIndex(
                (p: any) => p.id === product.id
            )
            if (existingProductIndex !== -1) {
                updatedSelectedProducts[existingProductIndex].quantity = null;
            } else {
                updatedSelectedProducts.push({ ...product, quantity: null });
            }

            setSelectedProducts(updatedSelectedProducts);
            updateSelectedProductsInfo(updatedSelectedProducts);
            setLastValidQty(prev => ({ ...prev, [product.id]: null }));
            setProductErrors((prev: any) => (
                {
                    ...prev,
                    [product.id]: "Quantity is required",
                }));
            return;
        }

        const quantity = parseInt(raw, 10);

        if (isNaN(quantity)) {
            setProductErrors((prev: any) => ({
                ...prev,
                [product.id]: "Quantity must be a number",
            }));
            return;
        }

        if (quantity < 0) {
            setProductErrors((prevErrors: any) => ({
                ...prevErrors,
                [product.id]: "Quantity cannot be negative",
            }));
            return;
        }

        if (quantity === 0) {
            setProductErrors((prevErrors: any) => ({
                ...prevErrors,
                [product.id]: "Quantity must be greater than 0",
            }));
            return;
        }

        // Valid (>0)
        setProductErrors((prevErrors: any) => (
            {
                ...prevErrors,
                [product.id]: undefined,
            }));

        const updatedSelectedProducts = [...selectedProducts];
        const existingProductIndex = updatedSelectedProducts.findIndex(
            (p: any) => p.id === product.id
        );
        if (existingProductIndex !== -1) {
            updatedSelectedProducts[existingProductIndex].quantity = quantity;
        } else {
            updatedSelectedProducts.push({ ...product, quantity });
        }

        setSelectedProducts(updatedSelectedProducts);
        updateSelectedProductsInfo(updatedSelectedProducts);
        setLastValidQty(prev => ({ ...prev, [product.id]: quantity }));
    };




    const handleChangeValues = (product: any, type: string, action?: string) => {
        const updatedSelectedProducts = [...selectedProducts];
        const existingProductIndex = updatedSelectedProducts.findIndex((p: any) => p.id === product.id);
        const existingProduct = updatedSelectedProducts[existingProductIndex];
        let quantity = existingProduct ? existingProduct.quantity : 0;
        if (type === "increment") {
            setLastValidQty(prev => {
                const updated = { ...prev };
                delete updated[product.id];
                return updated;
            });
            setProductErrors((prev: any) => {
                const updated = { ...prev };
                delete updated[product.id];
                return updated;
            });
            setView(false);
            if (action === "Add") {
                quantity = 1;
            }
            else {
                quantity += 1;
            }
        } else if (type === "decrement") {
            quantity -= 1;
        }


        if (quantity > 0) {
            if (existingProductIndex !== -1) {
                updatedSelectedProducts[existingProductIndex].quantity = quantity;
            } else {
                updatedSelectedProducts.push({ ...product, quantity: 1 });
            }
        } else {
            setLastValidQty(prev => {
                const updated = { ...prev };
                delete updated[product.id];
                return updated;
            });
            setProductErrors((prev: any) => {
                const updated = { ...prev };
                delete updated[product.id];
                return updated;
            });
            if (existingProductIndex !== -1) {
                updatedSelectedProducts.splice(existingProductIndex, 1);
            }
        }

        setSelectedProducts(updatedSelectedProducts);
        updateSelectedProductsInfo(updatedSelectedProducts);
    };


    const handleChangeUnit = (e: ChangeEvent<HTMLSelectElement>, product: any) => {
        const updated = [...selectedProducts];
        const index = updated.findIndex((p) => p.id === product.id);
        if (index === -1) return;
        const item = updated[index];
        const basePrice = item.batch_pricing[0].price;
        const qty = item.quantity;
        const unit = e.target.value;

        let price = basePrice * qty;

        if (unit === "gram" || unit === "ml") {
            price = (basePrice / 1000) * qty;
        }

        item.batch_pricing[0].unit = unit;
        item.price = price;
        setSelectedProducts(updated);
    };


    const updateSelectedProductsInfo = (updatedSelectedProducts: any[]) => {
        const summaryInfo = updatedSelectedProducts.map(product => {
            if (product && product.batch_pricing && product.batch_pricing[0] && typeof product.batch_pricing[0].price === 'number') {
                return {
                    name: product.name,
                    quantity: product.quantity || 0,
                    price: product.batch_pricing[0].price,
                    total: (product.quantity || 0) * product.batch_pricing[0].price
                };
            } else {
                return {
                    name: "",
                    quantity: 0,
                    price: 0,
                    total: 0
                };
            }
        });
    };

    const calculateTotalAmount = () => {
        return selectedProducts.reduce((total: any, product: any) => {
            let totalPrice = 0;
            if (product?.batch_pricing && (product?.batch_pricing[0]?.unit === "gram" || product?.batch_pricing[0]?.unit === "ml")) {
                totalPrice = total + (product.quantity / 1000) * product.batch_pricing[0]?.price;
            }
            else {
                totalPrice = total + product.quantity * product.batch_pricing[0]?.price;
            }
            return totalPrice;
        }, 0);
    };

    const removeProduct = (product: any) => {
        for (let i = 0; i < productsData?.length; i++) {
            if (productsData[i]?.id === product?.id) {
                productsData[i].quantity = 0;
                productsData[i].removed_product = true
                setProductsData([...productsData])
            }
        }
        const updatedProductsData = productsData.map((p: any) => {
            if (p.id === product.id) {
                return {
                    ...p,
                    quantity: 0,
                    removed_product: true
                };
            }
            return p;
        });
        setProductsData(updatedProductsData)
        const updatedSelectedProducts = selectedProducts.filter((p: any) => p.id !== product.id);
        setSelectedProducts(updatedSelectedProducts);
        updateSelectedProductsInfo(updatedSelectedProducts);
    };

    const onPlaceYourOrder = async () => {
        const placedOrderItems: any = [];
        selectedProducts?.forEach((el: any) => {
            placedOrderItems.push({
                product_id: el?.id,
                quantity: el?.batch_pricing[0]?.unit === "gram" || el?.batch_pricing[0]?.unit === "ml" ? (el?.quantity / 1000) : el?.quantity
            });
        });
        localStorage.setItem('userDetails', userDetailsData?.contact_number);
        const { building_no, buildingstreetname, landmark, state, villagetowncity } = userDetailsData;
        const preparedAddress = {
            building_no, buildingstreetname, landmark, state, villagetowncity
        }
        userDetailsData.address = preparedAddress
        userDetailsData.ship_to_address = preparedAddress;
        const orderData = {
            bu: buDetailsData._id,
            buyer: userDetailsData,
            products: placedOrderItems
        };
        await ApisService.getTransactionData('createBUOrderForm', dataEncrypt(JSON.stringify(orderData)));
        setShowUserDetailsForm(false);
        setSelectedProducts([]);
        navigation(`/${routerParams.id}/success-order?bu=${buDetailsData?.business_name}`);
        // setButtonStatus(true);
    }

    const onClickSubmit = () => {
        const isValid: any = isUserDetailsValid();
        if (isValid) {
            setShowUSerDetailsData(true);
            setShowUserDetailsForm(false);
            setShowPlaceOrderButtonText(true);
        } else {
            setShowPlaceOrderButtonText(false);
        }
    }

    const onClickBackToProductsList = () => {
        setShowUserDetailsForm(false);
        setShowUSerDetailsData(false)
    }

    const isUserDetailsValid = () => {
        const errors: any = {};
        if (!userDetailsData.name) {
            errors.name = "Please enter your name";
        }
        if (!userDetailsData.contact_number) {
            errors.contact_number = "Please enter your mobile number";
        } else if (!mobileNumberRegex.test(userDetailsData.contact_number)) {
            errors.contact_number = "Please enter valid mobile number"
        }
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleInput = (e: any) => {
        const { name, value } = e.target;
        setUserDetailsData((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
        setFormErrors((prevErrors: any) => ({
            ...prevErrors,
            [name]: validateSpecificFeild(name, value),
        }));
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const { key } = e;
        if (!/^\d$/.test(key) && !['Tab', 'Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(key)) {
            e.preventDefault();
        }
    };

    const validateSpecificFeild = (name: any, value: any) => {
        if (name === "contact_number") {
            if (!value) {
                return "Please enter your mobile number";
            } else if (!mobileNumberRegex.test(value)) {
                return "Please enter valid mobile number";
            }
        } else if (name === "email") {
            if (value?.length > 0 && !emailRegex.test(value)) {
                return "Please enter valid email ";
            }
        }
        return "";
    }

    const onClickContinue = () => {
        setShowUserDetailsForm(true);
    };

    const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
        const term = e.target.value;
        setSearchTerm(term);
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => {
            setDebouncedSearchTerm(term);
        }, 500);
    };

    const showPopup = (data: any, index: number) => {
        setShow(true);
        setSelectedProduct({ product: data, index: index });
    }

    const closePopup = () => {
        setShow(false);
        setSelectedProduct(null);
    }

    const hasNullValue = useMemo(() => {
        return Object.values(lastValidQty).some(
            value => value === null || value === undefined
        );
    }, [lastValidQty]);



    return (
        <div className='order-screen'>
            <div className='primary-background p-2 align-items-center d-flex justify-content-between'>
                <div ><div>Order Form for</div> <b style={{ fontSize: 24 }}>{buDetailsData?.business_name}</b></div>
                <div className='text-end'><img src={LOGO} alt="" height={60} /></div>
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-7 col-lg-8'>
                        {loading &&
                            <div className="text-center p-5">
                                <div className="spinner-border" role="status">
                                    <span className="sr-only"></span>
                                </div>
                            </div>
                        }
                        {!loading && (
                            <div className='my-3'>
                                {!showUSerDetailsData && !showUserDetailsForm && (<>
                                    <h5 className='text-center fw-bold'>Select Products & Quantity to Place Order to {buDetailsData?.business_name}</h5>
                                    <input
                                        type="search"
                                        className="form-control rounded-4 mb-3"
                                        value={searchTerm}
                                        placeholder="Search products..."
                                        onChange={handleSearch}
                                    />
                                    <div style={{ height: "500px", overflowY: "auto" }}>
                                        {productsData?.length > 0 && productsData?.map((product: any, index: number) => (
                                            <div className='card mb-2 rounded-4 box-shadow' style={{ border: '1px solid #E9ECEF' }} key={index}>
                                                <div className='card-body pe-1'>
                                                    <div className='row align-items w-100'>
                                                        <div className='col-2 p-0' onClick={() => showPopup(product, index)}>
                                                            {product?.images && <img src={`${AppConfig?.IMAGE_PATH}${product?.images}`} className='product-image rounded w-100' />}{!product?.images && <img src={NoProductImage} className='product-image w-100 rounded' />}
                                                        </div>
                                                        <div className='col-10 p-0 px-2'>
                                                            <div className='fs-14 text-truncate' onClick={() => showPopup(product, index)}>{product?.name}</div>
                                                            <div className='row mx-1 align-items'>
                                                                <div className='fw-bold my-1 fs-16 col-4' onClick={() => showPopup(product, index)}><span className='fs-14'>₹</span> {product?.batch_pricing[0]?.price ? product?.batch_pricing[0]?.price : "-"}</div>
                                                                <div className='col-8 text-end pe-0'>
                                                                    {selectedProducts.find((p: any) => p.id === product.id) ? <div className="d-flex justify-content-end align-items-center">
                                                                        <div className="d-flex justify-content-center align-items-center text-center quantity-width">
                                                                            <FaMinus
                                                                                className="cursor-pointer"
                                                                                size={18}
                                                                                onClick={() => handleChangeValues(product, "decrement")}
                                                                            />
                                                                            <input
                                                                                type="number"
                                                                                name="quantity"
                                                                                className="form-control border-dark text-center py-1 my-2 mx-2 fs-14 px-1"
                                                                                onChange={(e) => handleInputChange(e, product, index)}
                                                                                value={
                                                                                    selectedProducts.find((p: any) => p.id === product.id)?.quantity ?? ""
                                                                                }
                                                                                min="0"
                                                                            />

                                                                            <FaPlus
                                                                                className="cursor-pointer"
                                                                                size={18}
                                                                                onClick={() => handleChangeValues(product, "increment")}
                                                                            />
                                                                        </div>
                                                                        {(product?.unit === "kg") && <select className="form-select form-select-sm w-auto fs-14 ms-1" onChange={(e) => handleChangeUnit(e, product)} value={selectedProducts.find((p: any) => p.id === product.id)?.batch_pricing[0]?.unit}>
                                                                            <option className='kg'>kg</option>
                                                                            <option className='gram'>gram</option>
                                                                        </select>}
                                                                        {(product?.unit === "litre") && <select className="form-select form-select-sm w-auto fs-14 ms-1" onChange={(e) => handleChangeUnit(e, product)} value={selectedProducts.find((p: any) => p.id === product.id)?.batch_pricing[0]?.unit}>
                                                                            <option className='litre'>litre</option>
                                                                            <option className='ml'>ml</option>
                                                                        </select>}
                                                                    </div> : (<div className='text-center'>
                                                                        <button className='bg-light rounded primary-color py-1 mt-1 px-4 fw-bold border' onClick={() => handleChangeValues(product, "increment", "Add")}>ADD</button>
                                                                    </div>)}
                                                                    {selectedProducts.find((p: any) => p.id === product.id) && productErrors[product.id] && (
                                                                        <small className="text-danger">{productErrors[product.id]}</small>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        {productsData?.length === 0 && (
                                            <div className='d-flex flex-column justify-content-center mt-5 pt-5 align-items-center'>
                                                <div>
                                                    <img src={NordersImage} alt="" className='' />
                                                </div>
                                                <div className='text-center'>No Products Found</div>
                                            </div>
                                        )}
                                    </div>
                                </>)}
                                {showUserDetailsForm && (
                                    <div >
                                        <div className='my-3 ms-2 fw-bold'>Please enter your details</div>
                                        <div className='mx-2 px-3 mx-md-auto col-11 col-md-8 col-lg-6 rounded-2 p-2'>
                                            <div className="mb-3">
                                                <label htmlFor="exampleFormControlInput1" className="form-label">Name</label><span className='text-danger ms-1'>*</span>
                                                <input type="text" name="name" className="form-control" id="exampleFormControlInput1" defaultValue={userDetailsData?.name} onChange={handleInput} placeholder="Please enter your name" />
                                                {formErrors.name && (<div className="text-danger text-start w-100">{formErrors.name}</div>)}
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="exampleFormControlInput1" className="form-label">Mobile Number</label><span className='text-danger ms-1'>*</span>
                                                <input type="text" maxLength={10} name="contact_number" className="form-control number-only" id="exampleFormControlInput1" onKeyDown={handleKeyDown} defaultValue={userDetailsData?.contact_number} onChange={handleInput} placeholder="Please enter your mobile number" />
                                                {formErrors.contact_number && (<div className="text-danger text-start w-100">{formErrors.contact_number}</div>)}
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="exampleFormControlInput1" className="form-label">Email</label>
                                                <input type="email" name="email" className="form-control" id="exampleFormControlInput1" defaultValue={userDetailsData?.email} onChange={handleInput} placeholder="Please enter your email" />
                                                {formErrors.email && (<div className="text-danger text-start w-100">{formErrors.email}</div>)}
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="exampleFormControlTextarea1" className="form-label">Address</label>
                                                <div className="border p-3">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="">Building</label>
                                                        <input type="text" name="building_no" id="" className='form-control' onChange={handleInput} />
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="">Street Address</label>
                                                        <input type="text" name="buildingstreetname" id="" className='form-control' onChange={handleInput} />
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="">Locality/Landmark</label>
                                                        <input type="text" name="landmark" id="" className='form-control' onChange={handleInput} />
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="">City</label>
                                                        <input type="text" name="villagetowncity" id="" className='form-control' onChange={handleInput} />
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="">State</label>
                                                        <input type="text" name="state" id="" className='form-control' onChange={handleInput} />
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="">Pincode</label>
                                                        <input type="text" name="state" id="" className='form-control' onChange={handleInput} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='text-center mx-auto'>
                                                <button className='btn btn-primary mx-auto cursor-pointer py-2 primary-background mx-3 rounded-pill w-50' onClick={onClickSubmit}>Submit</button>
                                                <button className='cursor-pointer bg-transparent rounded-0 border-none primary-color' onClick={onClickBackToProductsList}>Back to products list</button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {showUSerDetailsData && (
                                    <div>
                                        <div className='card rounded-4 primary-border my-3'>
                                            <div className='my-2 ms-3 fw-bold '>Seller Details</div>
                                            <div className="mx-3">
                                                <div className='primary-color fw-bold'>{buDetailsData?.business_name}</div>
                                                <div className='fs-14'>{buAddressData?.plot_no ? `${buAddressData?.plot_no}, ` : ""}{buAddressData?.buildinghousenumber ? `${buAddressData?.buildinghousenumber},` : ""}</div>
                                                <div className='fs-14'>{buAddressData?.building_no ? `${buAddressData?.building_no}, ` : ""}{buAddressData?.landmark ? `${buAddressData?.landmark}, ` : ""}{buAddressData?.buildingstreetname ? `${buAddressData?.buildingstreetname},` : ""}</div>
                                                <div className='fs-14'>{buAddressData?.villagetowncity ? `${buAddressData?.villagetowncity}, ` : ""}{buAddressData?.taluk}</div>
                                                <div className='fs-14'>{buAddressData?.district ? `${buAddressData?.district}, ` : ""}{buAddressData?.state ? buAddressData?.state : ""} - {buAddressData?.postcode ? buAddressData?.postcode : ""}</div>
                                                <div className='fs-14'>{buAddressData?.country}</div>
                                                {buAddressData?.phone_number_on_invoice && <div className='fs-14 mb-2'>Phone No : {buAddressData?.phone_number_on_invoice ? buAddressData?.phone_number_on_invoice : ""} | Email : {buAddressData?.email_on_invoice ? buAddressData?.email_on_invoice : ""}</div>}
                                            </div>
                                        </div>
                                        <div className='card rounded-4 primary-border my-3'>
                                            <div className='my-1 ms-3 fw-bold '>Your Details</div>
                                            <div className="mx-3">
                                                <div className='fs-14'>{userDetailsData?.name}</div>
                                                <div className='fs-14'>{userDetailsData?.contact_number}</div>
                                                <div className='fs-14 mb-2'>{userDetailsData?.address}</div>
                                            </div>
                                        </div>
                                        <div className='user-details-view'>
                                            <div className={`my-3 py-2 fw-bold card rounded-4 primary-border ${selectedProducts?.length > 0 ? "d-block" : "d-none"}`}>
                                                <div className={`ps-3 ${selectedProducts?.length > 0 ? "d-block" : "d-none"}`}>Order Summary</div>
                                                <div>
                                                    <div className='border-bottom mx-2 fs-14'>
                                                        {selectedProducts?.length > 0 && selectedProducts?.map((product: any, index: number) => (
                                                            <div className='' key={index}>
                                                                <div className='p-2'>
                                                                    {product?.quantity && (
                                                                        <div className='d-flex justify-content-between'>
                                                                            <div className='fw-normal'><b>{product?.quantity}</b> x <span className='-nfwone'>{product?.name}</span></div>
                                                                            <div className='d-flex justify-content-end mx-2 w-100'>
                                                                                <div className='fw-normal'>{formatCurrency(product?.quantity * (product?.batch_pricing[0]?.unit === "gram" || product?.batch_pricing[0]?.unit === "ml" ? (product?.batch_pricing[0]?.price / 1000) : product?.batch_pricing[0]?.price))}</div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div className='border-top-1 mx-1'>
                                                        {selectedProducts?.length > 0 && (
                                                            <div className='my-1'>
                                                                <div className='p-2'>
                                                                    <div className='mx-1'>
                                                                        <div className='d-flex justify-content-between'>
                                                                            <div className='text-start fs-6 ms-1'>Total</div>
                                                                            <div className='text-end pe-2'>{formatCurrency(calculateTotalAmount())}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {selectedProducts?.length > 0 && (
                                                <div className='text-center mb-1'>
                                                    {!showUSerDetailsData && !showUserDetailsForm && <button className="btn btn-primary mx-auto cursor-pointer py-2 primary-background mx-3 rounded-pill w-50 mb-2" onClick={onClickContinue}>Continue</button>}
                                                    {showUSerDetailsData && showUserDetailsForm && <button className={`btn btn-primary mx-auto cursor-pointer py-2 primary-background mx-3 rounded-pill w-50 mb-2`} onClick={onPlaceYourOrder}>Place your order</button>}
                                                    {showUSerDetailsData && showUserDetailsForm && <button className='cursor-pointer bg-transparent rounded-0 border-none primary-color' onClick={onClickBackToProductsList}>Back to products list</button>}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    {(!showUserDetailsForm) && <div className='col-md-5 col-lg-4 '>
                        <div className=' d-none d-md-block'>
                            <div className={`my-3 py-2 fw-bold card rounded-4 primary-border ${selectedProducts?.length > 0 ? "d-block" : "d-none"}`}>
                                <div className={`ps-3 ${selectedProducts?.length > 0 ? "d-block" : "d-none"}`}>Order Summary</div>
                                <div>
                                    <div className='border-bottom mx-2'>
                                        {selectedProducts?.length > 0 && selectedProducts?.map((product: any, index: number) => (
                                            <div className='' key={index}>
                                                <div className='p-2'>
                                                    {product?.quantity && (
                                                        <div className='d-flex justify-content-between fs-14'>
                                                            <div className='fw-normal'><b>{product?.quantity} {product?.batch_pricing[0]?.unit}</b> x <span className='-nfwone'>{product?.name}</span></div>
                                                            <div className='d-flex justify-content-end mx-2'>
                                                                <div className='fw-normal'>{formatCurrency(product?.quantity * (product?.batch_pricing[0]?.unit === "gram" || product?.batch_pricing[0]?.unit === "ml" ? (product?.batch_pricing[0]?.price / 1000) : product?.batch_pricing[0]?.price))}</div>
                                                                <div className='ms-auto me-0 my-0 py-0' style={{ width: "10%" }}> <div onClick={() => removeProduct(product)}><PiTrashBold size={20} className='text-danger cursor-pointer' /></div></div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className='border-top-1 mx-1'>
                                        {selectedProducts?.length > 0 && (
                                            <div className='my-1'>
                                                <div className='p-2'>
                                                    <div className='mx-1'>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className='text-start fs-6 ms-1'>Total</div>
                                                            <div className='text-end me-4 pe-2'>{formatCurrency(calculateTotalAmount())}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {selectedProducts?.length > 0 && (
                            <div className='text-center mb-1'>
                                {!showUSerDetailsData && (!showUserDetailsForm && !hasNullValue) && <button className="btn btn-primary mx-auto cursor-pointer py-2 primary-background mx-3 rounded-pill w-50 mb-2 d-none d-md-block" onClick={onClickContinue}>Continue</button>}
                                {showUSerDetailsData && !showUserDetailsForm && <button className={`btn btn-primary mx-auto cursor-pointer py-2 primary-background mx-3 rounded-pill w-50 mb-2`} onClick={onPlaceYourOrder}>Place your order</button>}
                                {showUSerDetailsData && !showUserDetailsForm && <button className='cursor-pointer bg-transparent rounded-0 border-none primary-color' onClick={onClickBackToProductsList}>Back to products list</button>}
                            </div>
                        )}
                        {selectedProducts?.length === 0 && (
                            <div className='d-flex flex-column justify-content-center my-5 my-md-0 mt-md-5 pt-md-5 align-items-center '>
                                <div className='mt-4 pt-3'>
                                    <img src={NordersImage} alt="" className='' />
                                </div>
                                <div className='text-center'>You have not selected any products</div>
                            </div>)}
                    </div>}
                    {selectedProducts?.length !== 0 && !showUSerDetailsData && !showUserDetailsForm && !view && (
                        <div
                            className="d-flex justify-content-between align-items-center p-3 bg-success text-white position-fixed bottom-0 start-0 w-100 shadow-lg d-block d-md-none d-lg-none"
                            style={{
                                zIndex: 1050,
                                borderTopLeftRadius: "12px",
                                borderTopRightRadius: "12px",
                            }}
                        >
                            <button
                                className="btn btn-light text-success fw-bold px-4 py-2"
                                onClick={() => setView(true)}
                            >
                                View
                            </button>

                            <div className="text-center">
                                <div className="fw-bold">{selectedProducts?.length} item{selectedProducts?.length > 1 ? "s" : ""} added</div>
                                <div>{formatCurrency(calculateTotalAmount())}</div>
                            </div>
                            <>
                                {!hasNullValue ? <button
                                    className="btn btn-light text-success fw-bold px-4 py-2"
                                    onClick={onClickContinue}
                                >
                                    Continue
                                </button> : <>{" "}</>}
                            </>
                        </div>
                    )}


                    {selectedProducts?.length > 0 && !showUSerDetailsData && !showUserDetailsForm && <div><Offcanvas show={view} onHide={() => setView(false)} >
                        <Offcanvas.Header closeButton className='pb-0'>
                            <Offcanvas.Title>Order Products ({selectedProducts?.length})</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body className='pt-1'>
                            {selectedProducts?.length > 0 && selectedProducts?.map((product: any, index: number) => (
                                <div className='' key={index}>
                                    <div className='p-2'>
                                        {product?.quantity && (
                                            <div className='row align-items fs-14'>
                                                <div className='col-1 fw-bold'>{index + 1}.</div>
                                                <div className='col-8 fs-14'><b>{product?.quantity}</b> x <span className='fw-none'>{product?.name}</span></div>
                                                <div className='col-2'>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <div className="fw-normal">
                                                            {formatCurrency(product?.quantity * (product?.batch_pricing[0]?.unit === "gram" || product?.batch_pricing[0]?.unit === "ml" ? (product?.batch_pricing[0]?.price / 1000) : product?.batch_pricing[0]?.price))}
                                                        </div>
                                                        <div
                                                            className="text-danger cursor-pointer ms-2"
                                                            onClick={() => removeProduct(product)}
                                                        >
                                                            <PiTrashBold size={20} />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                            ))}
                            <div className='border-top-1 mx-1'>
                                {selectedProducts?.length > 0 && (
                                    <div className='my-1'>
                                        <hr className='my-0' />
                                        <div className='p-2'>
                                            <div className='mx-1'>
                                                <div className='d-flex justify-content-between'>
                                                    <div className='text-start fs-6 ms-1'>Total</div>
                                                    <div className='text-end me-4 pe-2'>{formatCurrency(calculateTotalAmount())}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Offcanvas.Body>
                    </Offcanvas></div>}
                </div>
            </div>
            <Modal show={show} centered className='rounded-4' onHide={() => closePopup()}>
                <Modal.Header closeButton className='fw-bold py-2 fs-5'>PRODUCT INFORMATION</Modal.Header>
                <Modal.Body>
                    <div className='text-center'>
                        {selectedProduct?.product?.images && <img src={`${AppConfig?.IMAGE_PATH}${selectedProduct?.product?.images}`} className='select-product-image rounded w-100' />}{!selectedProduct?.product?.images && <img src={NoProductImage} className='select-product-image w-100 rounded' />}
                        <div className='fs-16 fw-bold'>{selectedProduct?.product?.name}</div>
                        <div className='row align-items'>
                            <div className='col-6 fw-bold'>
                                <span >₹</span> {selectedProduct?.product?.batch_pricing[0]?.price ? selectedProduct?.product?.batch_pricing[0]?.price : "-"}
                            </div>
                            <div className='col-6'>
                                {selectedProducts.find((p: any) => p.id === selectedProduct?.product.id) ? (
                                    <div className='d-flex justify-content-end align-items-center'>
                                        <div className='d-flex justify-content-center align-items-center text-center quantity-width'>
                                            <FaMinus
                                                className="cursor-pointer"
                                                size={18}
                                                onClick={() => handleChangeValues(selectedProduct?.product, "decrement")}
                                            />
                                            <input
                                                type="number"
                                                name="quantity"
                                                className="form-control border-dark text-center py-1 my-2 mx-2 fs-14 px-1"
                                                onChange={(e) => handleInputChange(e, selectedProduct?.product, selectedProduct?.index)}
                                                value={
                                                    selectedProducts.find((p: any) => p.id === selectedProduct?.product.id)?.quantity ?? ""
                                                }
                                                min="0"
                                            />
                                            <FaPlus
                                                className="cursor-pointer"
                                                size={18}
                                                onClick={() => handleChangeValues(selectedProduct?.product, "increment")}
                                            />
                                        </div>
                                        {(selectedProduct?.product?.unit === "kg") && <select className="form-select form-select-sm w-auto fs-14 ms-1" onChange={(e) => handleChangeUnit(e, selectedProduct?.product)} value={selectedProducts.find((p: any) => p.id === selectedProduct?.product.id)?.batch_pricing[0]?.unit}>
                                            <option className='kg'>kg</option>
                                            <option className='gram'>gram</option>
                                        </select>}
                                        {(selectedProduct?.product?.unit === "litre") && <select className="form-select form-select-sm w-auto fs-14 ms-1" onChange={(e) => handleChangeUnit(e, selectedProduct?.product)} value={selectedProducts.find((p: any) => p.id === selectedProduct?.product.id)?.batch_pricing[0]?.unit}>
                                            <option className='litre'>litre</option>
                                            <option className='ml'>ml</option>
                                        </select>}
                                    </div>
                                ) : (<div className='text-center'>
                                    <button className='bg-light rounded primary-color py-1 mt-1 px-4 fw-bold border' onClick={() => handleChangeValues(selectedProduct?.product, "increment", "Add")}>ADD</button>
                                </div>
                                )
                                }
                                {selectedProducts.find((p: any) => p.id === selectedProduct?.product.id) && productErrors[selectedProduct?.product.id] && (
                                    <small className="text-danger">{productErrors[selectedProduct?.product.id]}</small>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state: any) => ({
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    updateBuDetails: (data: any) => { dispatch({ type: BU_DETAILS, data }) }
})
export default connect(mapStateToProps, mapDispatchToProps)(OrderFormListPage);